import { Text } from '@chakra-ui/react';

export const Error403: React.FunctionComponent = () => (
  <Text>認証コードがありません</Text>
);
export const Error404: React.FunctionComponent = () => (
  <Text>報告するものがありません</Text>
);
export const Error500: React.FunctionComponent = () => (
  <Text>サーバエラーです．問い合わせてください．</Text>
);
